import { useIntl } from '@grandvisionhq/state';
import { getCustomShortDateFormat } from '../../../utils/get-custom-short-date-format.js';

const useRangeByWeeks = (weeks)=>{
    const { locale  } = useIntl();
    const firstWeek = weeks[0];
    const [lastWeek] = weeks.slice(-1);
    const firstDay = firstWeek === null || firstWeek === void 0 ? void 0 : firstWeek[0];
    var ref;
    const [lastDay] = (ref = lastWeek === null || lastWeek === void 0 ? void 0 : lastWeek.slice(-1)) !== null && ref !== void 0 ? ref : [];
    return firstDay && lastDay && `${getCustomShortDateFormat(firstDay, locale)} - ${getCustomShortDateFormat(lastDay, locale)}`;
};

export { useRangeByWeeks };
//# sourceMappingURL=use-range-by-weeks.js.map
